import * as flowConfig from "flows/text-mining/config";
import { TextMiningProject } from "flows/text-mining/interfaces";

export const getDataFileId = (project: TextMiningProject) =>
  project.data_files[flowConfig.INPUT_DATA];
